import classNames from 'classnames';
import { Button, Heading } from 'yoso';
import { useLogin } from '~/components/Auth';
import { BaseCard, BaseCardProps } from '~/components/Card';
import { T } from '~/components/I18n';
import gift from '~/components/Icon/gift.png';
import shiningBox from '~/components/Icon/shiningBox.png';
import { Chevron } from '~/components/Icon/v2/Chevron';
import styles from './SignUpCta.module.scss';

export type SignUpCtaProps = {
  className?: string;
};

export const SignUpCta = ({ className }: SignUpCtaProps) => {
  const login = useLogin();
  return (
    <Button<BaseCardProps>
      as={BaseCard}
      className={classNames(styles.root, className)}
      size="large"
      shadow
      onClick={login}
      data-event="click"
      data-event-target="signup_login_banner_in_home"
      data-event-cartegory="signup_login">
      <img src={gift} width={52} height={52} alt="Sign up Citizen" className={styles.asideLeft} />
      <div className={styles.body}>
        <Heading level={4} className={styles.title}>
          <T name="citizen_home_loginbanner_title" />
        </Heading>
        <p className={styles.description}>
          <T name="citizen_home_loginbanner_desc" />
          <Chevron />
        </p>
        <Heading level={4} className={styles.titlePc}>
          <T name="citizen_home_loginbanner_title_pc" />
        </Heading>
      </div>
      <img
        src={shiningBox}
        width={78}
        height={78}
        alt="Sign up Citizen"
        className={styles.asideRight}
      />
    </Button>
  );
};
